import { useEffect } from 'react'

const STORAGE_KEY = 'utmParams'

// Google Ads click identifiers, read straight from the landing URL alongside
// utm_* params. gclid is the standard click id; gbraid/wbraid are its iOS
// privacy-safe variants (used when ITP/ATT suppress gclid); gad_source marks
// the ad surface.
const GOOGLE_CLICK_PARAMS = ['gclid', 'gbraid', 'wbraid', 'gad_source']

const getStoredUtmParams = (): Record<string, string> => {
  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY)
    return stored ? JSON.parse(stored) : {}
  } catch {
    return {}
  }
}

const useUtmStorage = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const utmParams: Record<string, string> = {}

    for (const [key, value] of params) {
      if (key.startsWith('utm_') || GOOGLE_CLICK_PARAMS.includes(key)) {
        utmParams[key] = value
      }
    }

    if (Object.keys(utmParams).length > 0) {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utmParams))
    }
  }, [])

  return { getStoredUtmParams }
}

export default useUtmStorage
